export interface Testimonial {
  id: number
  quote: string
  // Words/phrases to highlight in --fire color (wrapped in <mark>)
  highlights: string[]
  name: string
  title: string
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    quote:
      'Working with Abdelrahman was a game-changer for our web presence. His expertise transformed our outdated website into a sleek, user-friendly platform that significantly boosted customer engagement.',
    highlights: ['game-changer', 'transformed', 'significantly boosted'],
    name: 'Seif Eltohamy',
    title: 'Content Creator',
  },
  {
    id: 2,
    quote:
      'His ability to understand our unique business needs and translate them into a fully functional web application was impressive. Delivered on time and exceeded expectations.',
    highlights: ['impressive', 'exceeded expectations'],
    name: 'Mahmoud Khalid',
    title: 'Clinic Owner',
  },
  {
    id: 3,
    quote:
      'Exceptional skill and creativity in developing our custom application. His proactive approach to problem-solving helped us achieve our goals efficiently.',
    highlights: ['Exceptional skill', 'proactive approach'],
    name: 'Mohamed Fahhy',
    title: 'Instructor',
  },
]
